import { Container, Grid } from 'theme-ui';
import { useState } from 'react';
import GoogleMap from '@features/showroom/sections/Map/Components/GoogleMap/GoogleMap';
import LocationSelect from '@features/showroom/sections/Map/Components/LocationSelect/LocationSelect';
import PostcodeFilter from '@features/showroom/sections/Map/Components/PostcodeFilter/PostcodeFilter';
import { ILocationItems } from '@features/showroom/typescript';
import styles from '@features/showroom/sections/Map/MapSection.styles';
type PropsType = {
  locations: Array<ILocationItems>;
};
const MapSection = ({
  locations
}: PropsType) => {
  const [coordinate, setCoordinate] = useState<Array<ILocationItems>>([locations[0]]);
  const [filterLocations, setFilterLocations] = useState<Array<ILocationItems>>([]);
  const locationData: Array<ILocationItems> = filterLocations.length > 0 ? filterLocations : locations;
  const mapLocations: Array<ILocationItems> = coordinate.length > 0 ? coordinate : filterLocations;
  return <Container sx={styles.mapSection}>
      <Grid sx={styles.filterHeader}>
        <PostcodeFilter locations={locations} setFilterLocations={setFilterLocations} setCoordinate={setCoordinate} />
      </Grid>
      <Grid sx={styles.mapRow}>
        <div sx={styles.locationCol}>
          <div sx={styles.locationList(locationData.length)}>
            {locationData.map(item => <LocationSelect key={item.id} location={item} setCoordinate={setCoordinate} />)}
          </div>
        </div>
        <div sx={styles.mapCol}>
          <GoogleMap mapLocations={mapLocations} />
        </div>
      </Grid>
    </Container>;
};
export default MapSection;